/**
 * Product group option counting
 *
 * Blocks.php strips unpublished products, so a group configured in ACF can reach the
 * front end with nothing selectable in it.
 *
 * @package
 */

/**
 * Whether a sub-group has anything to select.
 *
 * @param {Object} subGroup Sub-group from the block config.
 * @return {boolean} True when the sub-group holds at least one product.
 */
export const subGroupHasOptions = subGroup => ( subGroup?.products?.length || 0 ) > 0;

/**
 * Count the selectable options in a group, including those in its sub-groups.
 *
 * @param {Object} group Product group from the block config.
 * @return {number} Number of products a visitor could pick.
 */
export const countGroupOptions = group =>
	( group?.products?.length || 0 ) +
	( group?.sub_groups || [] ).reduce(
		( sum, subGroup ) => sum + ( subGroup?.products?.length || 0 ),
		0,
	);
